import { useState, useCallback } from 'react';

/**
 * 长按检测 Hook
 * @param onLongPress 长按触发时的回调函数
 * @param delay 长按延迟时间（毫秒），默认 500ms
 * @returns 长按事件处理函数和状态
 */
export function useLongPress(
    onLongPress: () => void,
    delay: number = 500
) {
    const [longPressTimer, setLongPressTimer] = useState<NodeJS.Timeout | null>(null);
    const [isLongPressTriggered, setIsLongPressTriggered] = useState(false);

    const handleLongPressStart = useCallback(() => {
        setIsLongPressTriggered(false);
        // 设置长按计时器
        const timer = setTimeout(() => {
            setIsLongPressTriggered(true);
            onLongPress();
        }, delay);
        setLongPressTimer(timer);
    }, [onLongPress, delay]);

    const handleLongPressEnd = useCallback(() => {
        // 清除长按计时器
        if (longPressTimer) {
            clearTimeout(longPressTimer);
            setLongPressTimer(null);
        }
        // 延迟重置标志，确保单击事件能正确判断
        setTimeout(() => {
            setIsLongPressTriggered(false);
        }, 100);
    }, [longPressTimer]);

    return {
        handleLongPressStart,
        handleLongPressEnd,
        isLongPressTriggered
    };
}

